
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/personal/na-zhile",
      function () {
        return require("private-next-pages/[city]/personal/na-zhile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[city]/personal/na-zhile"])
      });
    }
  